// eslint-disable no-labels

// Values in this file should mirror values in variables.scss

function rem(base, multiplier = 1) {
  return `${base * multiplier}rem`;
}

// Colors, names generated here http://chir.ag/projects/name-thatColor/#6195ED
export const $abbeyGray = '#46464b';
export const $aliceBlue = '#f5fcff';
export const $athensGray = '#f3f4f6';
export const $azure400 = '#3091ec';
export const $azure600 = '#1371d6';
export const $black = '#000000';
export const $black05 = 'rgba(black, 0.05)';
export const $black15 = 'rgba(black, 0.15)';
export const $blue100 = '#e9f1f8';
export const $blue600 = '#1f73b7';
export const $blue700 = '#1371D6';
export const $blue800 = '#06243c';
export const $burntSienna = '#ed616a';
export const $butteryWhite = '#fffbea';
export const $boulderGray = '#767676';
export const $chaliceGray = '#c8c8c8';
export const $ebonyClayBlue = '#1e242f';
export const $ecruWhite = '#f6f4e7';
export const $eggwhiteYellow = '#fff5c4';
export const $gray = '#919191';
export const $gray200 = '#e9ebed';
export const $gray300 = '#d9dcde';
export const $gray400 = '#c2c8cc';
export const $gray500 = '#87929d';
export const $gray600 = '#68737d';
export const $gray700 = '#49545c';
export const $gray800 = '#2f3941';
export const $lilyWhite = '#e5f6ff';
export const $mineshaftBlack = '#252525';
export const $peachOrange = '#ffc799';
export const $pearlLustaWhite = '#fffcf1';
export const $red = '#cc3340';
export const $red100 = '#fff0f1';
export const $red200 = '#f5d5d8';
export const $red300 = '#f5b5ba';
export const $red400 = '#e35b66';
export const $red500 = '#d93f4c';
export const $red600 = '#cc3340';
export const $red700 = '#8c232c';
export const $red800 = '#681219';
export const $scorpionGray = '#5f5f5f';
export const $seashellPink = '#fff4eb';
export const $soapstone = '#fffbf8';
export const $sugarCaneGreen = '#f4ffef';
export const $white = '#ffffff';
export const $woodsmokeBlack = '#17171c';
export const $zirconBlue = '#f5f9ff';

// Typography
export const $fontStackHelvetica =
  '"Helvetica Neue", "Helvetica", "Arial", sans-serif';
export const $fontStackGaramond =
  '"Garamond", "Baskerville", "Baskerville Old Face", "Hoefler Text", "Times New Roman", serif';
export const $fontStackPrimary = `'Assistant', ${$fontStackHelvetica}`;
export const $fontStackSecondary = `'Sorts Mill Goudy', ${$fontStackGaramond}`;

// Font weights
export const $fontWeightBold = 700;
export const $fontWeightRegular = 400;
export const $fontWeightSemibold = 600;

// Font sizes
export const $fontBaseSize = 1;
export const $fontBaseRatio = 0.2;
export const $fontSize1 = rem(1, $fontBaseSize * ($fontBaseRatio * 5)); // 1.0rem
export const $fontSize2 = rem(1, $fontBaseSize * ($fontBaseRatio * 6)); // 1.2rem
export const $fontSize3 = rem(1, $fontBaseSize * ($fontBaseRatio * 7)); // 1.4rem
export const $fontSize4 = rem(1, $fontBaseSize * ($fontBaseRatio * 8)); // 1.6rem
export const $fontSize5 = rem(1, $fontBaseSize * ($fontBaseRatio * 9)); // 1.8rem
export const $fontSize6 = rem(1, $fontBaseSize * ($fontBaseRatio * 10)); // 2.0rem
export const $fontSize7 = rem(1, $fontBaseSize * ($fontBaseRatio * 12)); // 2.4rem
export const $fontSize8 = rem(1, $fontBaseSize * ($fontBaseRatio * 14)); // 2.8rem
export const $fontSize9 = rem(1, $fontBaseSize * ($fontBaseRatio * 15)); // 3.0rem

export const $fontLargeSize = 4;
export const $fontLarge1 = rem($fontLargeSize, $fontBaseRatio * 4); // 3.2rem
export const $fontLarge2 = rem($fontLargeSize, $fontBaseRatio * 5); // 4.0rem
export const $fontLarge3 = rem($fontLargeSize, $fontBaseRatio * 6); // 4.8rem
export const $fontLarge4 = rem($fontLargeSize, $fontBaseRatio * 7); // 5.6rem
export const $fontLarge5 = rem($fontLargeSize, $fontBaseRatio * 8); // 6.4rem
export const $fontLarge6 = rem($fontLargeSize, $fontBaseRatio * 9); // 7.2rem

// Leadings
export const $leadingUnit1 = 1;
export const $leadingUnit2 = 1.1;
export const $leadingUnit3 = 1.2;
export const $leadingUnit4 = 1.3;
export const $leadingUnit5 = 1.4;
export const $leadingUnit6 = 1.5;

// Letter spacings
export const $kerningBaseUnit = 0.1;
export const $kerningUnit1 = rem($kerningBaseUnit);
export const $kerningUnit2 = rem($kerningBaseUnit, 2);
export const $kerningUnit3 = rem($kerningBaseUnit, 3);
export const $kerningUnit4 = rem($kerningBaseUnit, 4);
export const $kerningUnit5 = rem($kerningBaseUnit, 5);

// Spacings
export const $spBaseUnit = 1;
export const $spBaseRatio = 0.5;
export const $spUnit1 = rem($spBaseUnit, $spBaseRatio);
export const $spUnit2 = rem($spBaseUnit, $spBaseRatio * 2);
export const $spUnit3 = rem($spBaseUnit, $spBaseRatio * 3);
export const $spUnit4 = rem($spBaseUnit, $spBaseRatio * 4);
export const $spUnit5 = rem($spBaseUnit, $spBaseRatio * 5);
export const $spUnit6 = rem($spBaseUnit, $spBaseRatio * 6);
export const $spUnit7 = rem($spBaseUnit, $spBaseRatio * 7);
export const $spUnit8 = rem($spBaseUnit, $spBaseRatio * 8);
export const $spUnit9 = rem($spBaseUnit, $spBaseRatio * 9);
export const $spUnit10 = rem($spBaseUnit, $spBaseRatio * 10);
export const $spUnit11 = rem($spBaseUnit, $spBaseRatio * 11);
export const $spUnit12 = rem($spBaseUnit, $spBaseRatio * 12);

// Border sizes
export const $borderBaseUnit = 0.1;
export const $borderUnit1 = rem($borderBaseUnit);
export const $borderUnit2 = rem($borderBaseUnit, 2);
export const $borderUnit3 = rem($borderBaseUnit, 3);
export const $borderUnit4 = rem($borderBaseUnit, 4);
export const $borderUnit5 = rem($borderBaseUnit, 5);

export const $borderRadiusBase = rem(0.4);

// Box shadows
export const $shadowBaseUnit = 0.1;
export const $shadowUnit1 = rem($shadowBaseUnit);
export const $shadowUnit2 = rem($shadowBaseUnit, 2);
export const $shadowUnit3 = rem($shadowBaseUnit, 3);
export const $shadowUnit4 = rem($shadowBaseUnit, 4);
export const $shadowUnit5 = rem($shadowBaseUnit, 5);

export const $shadowLarge1 = rem($shadowBaseUnit, 10);
export const $shadowLarge2 = rem($shadowBaseUnit, 11);
export const $shadowLarge3 = rem($shadowBaseUnit, 12);
export const $shadowLarge4 = rem($shadowBaseUnit, 13);
export const $shadowLarge5 = rem($shadowBaseUnit, 14);
export const $shadowLarge6 = rem($shadowBaseUnit, 15);

// Timings
export const $timingUnit1 = '0.1s';
export const $timingUnit2 = '0.2s';
export const $timingUnit3 = '0.3s';

// Z indexes
export const $zIndexNav = 1;
export const $zIndexNavItem = 2;
export const $zIndexNavList = 1;
